import config from '../plugins/bluejay/config';

function getHumanUserRole(roleName) {
  let humanUserRole = '';
  switch (roleName) {
    case config.roles.SUPER_ADMIN:
      humanUserRole = 'Super Admin';
      break;
    case config.roles.ADMIN:
      humanUserRole = 'Admin';
      break;
    case config.roles.ACCOUNT_OWNER:
      humanUserRole = 'Account Owner';
      break;
    case config.roles.MEMBER:
      humanUserRole = 'Business Member';
      break;
    case config.roles.AGENT:
      humanUserRole = 'Agent';
      break;
  }
  return humanUserRole;
}

export { getHumanUserRole };
